import React, { useState, useEffect } from 'react';
import { BEM, renderClassName } from '@feedfm/feed-util';
import './ScrubBar.scss';

const bem = new BEM( 'echo-chamber' );
interface ScrubBarProps {
  currentTime: number;
  duration: number;
  onSeek: ( time: number ) => void;
}

export const ScrubBar: React.FC<ScrubBarProps> = ( { currentTime, duration, onSeek } ) => {
  const [progress, setProgress] = useState<number>( 0 );

  useEffect( () => {
    setProgress( ( currentTime / duration ) * 100 );
  }, [currentTime, duration] );

  const handleSeek = ( event: React.MouseEvent<HTMLDivElement> ) => {
    const scrubBar = event.currentTarget;
    const seekTime = ( ( event.clientX - scrubBar.getBoundingClientRect().left ) / scrubBar.offsetWidth ) * duration;
    onSeek( seekTime );
  };

  return (
    <div className={ renderClassName( bem.el( 'scrub-bar' ) ) } onClick={ handleSeek }>
      <div className="progress" style={ { width: `${progress}%` } }></div>
    </div>
  );
};
